import { Input } from "./input";
import { Select } from "./select";
import { Textarea } from "./textarea";

export const Form = {
  Input,
  Select,
  Textarea,
};
